<div class="review-plan-wrapper" [@fadeInOnEnter] [@fadeOutOnLeave]>
    <h2 class="box-title">
      Review plan changes
    </h2>
    <div class="plan-box">
      <app-plan-review-box
        [reviewMode]="true"
        [planData]="preSelectedPlan"
        [billData]="billData">
      </app-plan-review-box>
    </div>
    <div class="subscribe-button-box">
      <app-main-button
        (onClick)="onSubscribe()"
        [buttonWidth]="'92vw'"
        [textColor]="'#FFFFFF'"
        [backgroundColor]="'#000000'"
        [buttonText]="'Subscribe'">
      </app-main-button>
      <app-main-button
        (onClick)="onCancel()"
        [buttonWidth]="'92vw'"
        [textColor]="'#000000'"
        [textDecoration]="'underline'"
        [backgroundColor]="'#FFFFFF'"
        [fontWeight]="'normal'"
        [buttonText]="'Cancel'">
      </app-main-button>
    </div>
  </div>